import { Alert, Snackbar } from '@mui/material';
import React, {
  createContext,
  useCallback,
  useContext,
  useMemo,
  useState,
} from 'react';

interface ErrorHandlerContextProps {
  showError: (message: string) => void;
}

const defaultValue = {
  showError: () => {},
};

const ErrorHandlerContext =
  createContext<ErrorHandlerContextProps>(defaultValue);

export const useErrorHandlerContext = () => useContext(ErrorHandlerContext);

export const ErrorHandlerContextHandler: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  const [open, setOpen] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  const showError = useCallback((message: string) => {
    setErrorMessage(message);
    setOpen(true);
  }, []);

  const handleClose = () => {
    setOpen(false);
  };

  const contextValue = useMemo(() => ({ showError }), [showError]);

  return (
    <ErrorHandlerContext.Provider value={contextValue}>
      <Snackbar open={open} autoHideDuration={6000} onClose={handleClose}>
        <Alert onClose={handleClose} severity={true ? 'error' : 'success'}>
          {errorMessage}
        </Alert>
      </Snackbar>
      {children}
    </ErrorHandlerContext.Provider>
  );
};
